import React from 'react'

import { FooterSprite } from '@/components/IconSprite'

const Logo: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return <FooterSprite name="logoTon" />
}

export default Logo
